import { BaseEditor, BaseRange, Descendant } from 'slate';
import { ReactEditor } from 'slate-react';

export type BlockTypes =
  | 'bulleted-list'
  | 'numbered-list'
  | 'heading-one'
  | 'heading-two'
  | 'heading-three'
  | 'heading-four'
  | 'heading-five'
  | 'heading-six'
  | 'paragraph';
export type AlignTypes = 'left' | 'center' | 'right' | 'justify';
export type MarkTypes = 'bold' | 'italic' | 'underline' | 'link';

export const LIST_TYPES = ['numbered-list', 'bulleted-list'];

interface BlockElement {
  type: BlockTypes;
  align?: AlignTypes;
  children: Descendant[];
}

export interface BulletedListElement extends BlockElement {
  type: 'bulleted-list';
}

export interface NumberedListElement extends BlockElement {
  type: 'numbered-list';
}

export interface HeadingOneElement extends BlockElement {
  type: 'heading-one';
}

export interface HeadingTwoElement extends BlockElement {
  type: 'heading-two';
}

export interface HeadingThreeElement extends BlockElement {
  type: 'heading-three';
}

export interface HeadingFourElement extends BlockElement {
  type: 'heading-four';
}

export interface HeadingFiveElement extends BlockElement {
  type: 'heading-five';
}

export interface HeadingSixElement extends BlockElement {
  type: 'heading-six';
}

export interface ParagraphElement extends BlockElement {
  type: 'paragraph';
}

export interface ListItemElement {
  type: 'list-item';
  children: Descendant[];
}

type CustomElement =
  | BulletedListElement
  | NumberedListElement
  | HeadingOneElement
  | HeadingTwoElement
  | HeadingThreeElement
  | HeadingFourElement
  | HeadingFiveElement
  | HeadingSixElement
  | ListItemElement
  | ParagraphElement;

export interface CustomText {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  link?: string;
  text: string;
}

export type CustomEditor = BaseEditor & ReactEditor;

declare module 'slate' {
  interface CustomTypes {
    Editor: CustomEditor;
    Element: CustomElement;
    Text: CustomText;
    Range: BaseRange & Record<string, unknown>;
  }
}
